module.exports = __webpack_public_path__ + "img/measurement_info_left_upper_thigh_front.b60030f1.jpg";